"use client";

import { LocalizedJoi } from "@/utils/localized-joi";
import type Joi from "joi";
import type { ValidationResult } from "joi";
import { type ChangeEvent, type ReactNode, useState } from "react";

import { InputErrorMessage } from "./input-error-message";
import { InputWrapper } from "./input-wrapper";
import type { InputBaseProps } from "./input.model";

interface InputEmailProps extends InputBaseProps {
  externalValidationError?: string | ReactNode;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  validationSchema?: Joi.StringSchema;
  value?: string;
}

export const InputEmail = ({
  disabled,
  id,
  labelledBy,
  name,
  onBlur,
  onChange,
  placeholder,
  readOnly,
  required,
  value,
  externalValidationError,
  validationSchema = required
    ? LocalizedJoi.string()
        .label("E-postadresse")
        .required()
        .email({ tlds: { allow: false } })
    : LocalizedJoi.string()
        .label("E-postadresse")
        .email({ tlds: { allow: false } })
        .allow(""),
}: InputEmailProps) => {
  const [validationError, setValidationError] = useState<ValidationResult<string> | undefined>();

  return (
    <InputWrapper>
      <input
        aria-labelledby={labelledBy}
        className="input input--email"
        disabled={disabled}
        id={id}
        name={name}
        onBlur={(e) => {
          if (onBlur) {
            onBlur();
          }
          setValidationError(validationSchema.validate(e.target.value));
        }}
        onChange={onChange}
        placeholder={placeholder}
        readOnly={readOnly}
        required={required}
        type="email"
        autoComplete={"email"}
        value={value}
      />

      <InputErrorMessage
        errorMessage={validationError?.error?.message}
        externalErrorMessage={externalValidationError}
      />
    </InputWrapper>
  );
};
